import { AbsRemixPage } from '@lemon8/web-app-shared/ssr';
import { Loading } from '~/components/loading';
import { FC } from 'react';

export abstract class TikTokSearchRemixPage extends AbsRemixPage {
  HeadSkeleton: FC = () => {
    return (
      <>
        <title>Lemon8 Loading...</title>
      </>
    );
  };
  BodySkeleton: FC = () => {
    return (
      <>
        <Loading variant="ball" />
      </>
    );
  };

  useRouteLoading = (): boolean => {
    return false;
  };
}
